import { Route, Routes } from 'react-router-dom';
import { BasketOwnersPage } from './BasketOwnersPage';
import { BasketItemsPage } from './BasketItemsPage';

export const BasketPageRoot = () => (
  <Routes>
    <Route path='/:userID' element={<BasketItemsPage />} />
    <Route path='*' element={<BasketOwnersPage />} />
  </Routes>
);
